// AURALIS — theme.js
// Minimal, dependency-free. Progressive enhancement only: every form here
// works via a normal HTML submit even if this file fails to load.

document.addEventListener('DOMContentLoaded', function () {
  // Mobile menu toggle
  var toggle = document.querySelector('[data-menu-toggle]');
  var header = document.querySelector('[data-site-header]');
  if (toggle && header) {
    toggle.addEventListener('click', function () {
      header.classList.toggle('is-menu-open');
      var expanded = header.classList.contains('is-menu-open');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  // Marquee: duplicate the track content once so the CSS animation loops seamlessly
  document.querySelectorAll('[data-marquee-track]').forEach(function (track) {
    var original = track.innerHTML;
    track.innerHTML = original + original;
  });

  // Quantity steppers (product page + cart)
  document.querySelectorAll('[data-qty-input]').forEach(function (wrap) {
    var input = wrap.querySelector('input[type="number"]');
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');
    if (!input) return;
    if (minus) {
      minus.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        var v = (parseInt(input.value, 10) || 1) + 1;
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  });

  // Product gallery: click a thumbnail to swap the main image (no JS required to view images at all —
  // thumbnails are plain <a> tags to the image file as a fallback if this script fails)
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        var fullSrc = thumb.getAttribute('data-full-src');
        if (main && fullSrc) {
          main.src = fullSrc;
        }
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  // Cart line quantity change: auto-submit the surrounding form (still works with JS off, just needs
  // a manual click on the existing "Update" button which we keep visually hidden but present)
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });
});
